// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const TemplatorService = {
    /**
     * ListTemplateTypes returns a list of ListTemplateTypes.
     * If Org id is provided - only returns TemplateTypes for which the org has customization flags enabled.
     * Using this endpoint requires no user or user grants.
     */
    ListTemplateTypes(fn, req) {
        return fn(`/messaging/templator/v2/template-types?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * ListTemplates returns a slice of templates belonging to given organization and matches one of the the provided template types.
     * UserId is optional. OrgId, BusinessGroupIds, and UserId are pulled from the token if there is one.
     * The templates are filtered by the provided business group IDs taken from the token if there is one.
     * Only returns templates that are not marked as deleted (where Template.deleted_at is null).
     * Only returns templates that the user has read access to, if provided. User is optional.
     * Only returns templates for which the org has customization flags enabled.
     */
    ListTemplates(fn, req) {
        return fn(`/messaging/templator/v2/templates?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Template returns a Template for the provided ID.
     * UserId is optional. OrgId, BusinessGroupIds, and UserId are pulled from the token if there is one.
     * This endpoint will only return the template if the user has read access to the asset.
     */
    Template(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/templator/v2/templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "GET" });
    },
    /**
     * TemplateCreate creates a new template.
     * UserId is optional. OrgId, BusinessGroupIds, and UserId are pulled from the token if there is one.
     * This endpoint will only create the templates if the user has edit access to all
     * business groups associated with the template being created.
     */
    TemplateCreate(fn, req) {
        return fn(`/messaging/templator/v2/templates`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * TemplateUpdate allows for minor changes to templates.
     * Attempts to update templates that are deleted will result in an error.
     * UserId is optional. OrgId, BusinessGroupIds, and UserId are pulled from the token if there is one.
     * A user can edit this asset if they have access through locations currently associated with the template, HOWEVER
     * a user must have access through all business groups that would be newly associated with this asset.
     */
    TemplateUpdate(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/templator/v2/templates/${req["templateId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * TemplateDelete will mark an existing template as deleted.
     * UserId is optional. OrgId, BusinessGroupIds, and UserId are pulled from the token if there is one.
     * This endpoint will only delete the template if the user has edit access to the asset.
     */
    TemplateDelete(fn, req) {
        try {
            fm.validateUrlParam(req["templateId"], "templateId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/messaging/templator/v2/templates/${req["templateId"]}?${fm.renderURLSearchParams(req, ["templateId"])}`, { method: "DELETE" });
    },
    /**
     * Render will return a rendered message based on the provided data bindings and template string.
     * The template is not looked up as it is in RenderTemplate(). This method does not do any URL shortening and doesn't append reply
     * instructions. Segment counts are calculated for SMS messages.
     * Using this endpoint requires no user or user grants.
     */
    Render(fn, req) {
        return fn(`/messaging/templator/v2/render`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * RenderBatch will return rendered messages based on the provided data bindings and template string.
     * The template is not looked up as it is in RenderTemplate().
     * This method does not do any URL shortening and doesn't append reply instructions.
     * Segment counts are calculated for SMS messages.
     * Using this endpoint requires no user or user grants.
     */
    RenderBatch(fn, req) {
        return fn(`/messaging/templator/v2/render-batch`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * RenderTemplate will return a rendered a message based on the interpolation data provided and a template looked up
     * from the provided template_id.
     * This endpoint will only render the message if the user has read access to the template.
     * Only calculates segments for SMS messages.
     */
    RenderTemplate(fn, req) {
        return fn(`/messaging/templator/v2/render-template`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Validate will validate a template string and return any errors.
     * Will return an error if the template string is missing any required dynamic fields.
     * Using this endpoint requires no user or user grants.
     */
    Validate(fn, req) {
        return fn(`/messaging/templator/v2/validate`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
